import { render } from "./ThePageInfo.vue?vue&type=template&id=4579dcbc&scoped=true"
import script from "./ThePageInfo.vue?vue&type=script&lang=js"
export * from "./ThePageInfo.vue?vue&type=script&lang=js"

import "./ThePageInfo.vue?vue&type=style&index=0&id=4579dcbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4579dcbc"]])

export default __exports__